module.exports = __webpack_public_path__ + "img/spaceship-04.d760ad04.png";